<template>
  <div>
    <loading-state :state="state"></loading-state>
    <div v-if="chatUser">
      <chatbot-register 
        v-if="chatUser.shouldRegister"
        :chatUser="chatUser"></chatbot-register>
      <chatbot-answer 
        v-else
        :chatUser="chatUser"></chatbot-answer>
    </div>
  </div>
</template>
<script>
import { CricketChatUser } from '@/models/cricket/chatbot'
import { DataState, AppState } from '@/state'

import ChatbotRegister from '@/components/cricket/ChatbotRegister.vue'
import ChatbotAnswer from '@/components/cricket/ChatbotAnswer.vue'

export default {
  components: {
    'ChatbotRegister': ChatbotRegister,
    'ChatbotAnswer': ChatbotAnswer
  },
  data () {
    return {
      chatUser: null,
      state: DataState.newLoading(),
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      const newTitle = 'Cricket Chatbot'
      AppState.updateActivePage(`cricket_chatbot`)
      AppState.updateTitles(newTitle, newTitle)

      if (CricketChatUser.State.user) {
        this.chatUser = CricketChatUser.State.user
        this.state.changeToLoaded()
      } else {
        CricketChatUser.getStart().then(chatUser => {
          this.chatUser = chatUser
          CricketChatUser.State.user = this.chatUser
          this.state.changeToLoaded()
        }).catch((error) => {
          console.error(error)
          this.state.changeToError(error)
        })
      }
    },
    prepareToReopen () {
    },
    refreshView () {

    },
  }
}
</script>
